import { type IConsumer, createConsumer } from '@cian/events-log';

export const TOPIC_USER = 'user';

let userConsumer: IConsumer;
export function getUserConsumer(): IConsumer {
  userConsumer ??= createConsumer({ topic: TOPIC_USER });

  return userConsumer;
}
